/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Low_Llama_EmergeInputs */

const fr_glad_low_llama_emerge = /** @type {(inputs: Glad_Low_Llama_EmergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une section`)
};

/**

* @param {Glad_Low_Llama_EmergeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const glad_low_llama_emerge = /** @type {((inputs?: Glad_Low_Llama_EmergeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Low_Llama_EmergeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_glad_low_llama_emerge(inputs)
});